import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

export const useNotifications = (userId) => {
    const [notifications, setNotifications] = useState({
        pendingRequests: 0,
        requests: []
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userId) {
            setLoading(false);
            return;
        }

        const q = query(
            collection(db, 'coachRequests'),
            where('toUid', '==', userId),
            where('status', '==', 'pending')
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const reqs = [];
            snapshot.forEach(doc => {
                reqs.push({ id: doc.id, ...doc.data() });
            });

            setNotifications({
                pendingRequests: snapshot.size,
                requests: reqs
            });
            setLoading(false);
        }, (error) => {
            console.error("Error fetching notifications:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [userId]);

    return { ...notifications, loading };
};
